import { useCallback, useEffect, useState } from 'react';
import handleInputChange from '../function/HandleInputsChange';
import Configuration from '../components/Configuration';
import CustomSelect from './CustomSelect';
import { useNavigation } from '../function/navigation';
import ModelComponent from '../components/ModelComponent';

function RenderValueComponent({
  inputs,
  setInputs,
  option,
  setOptions,
  disabled,
  value,
  unit,
}) {
  const { dispatch } = useNavigation();

  const setSpiralView = useCallback(
    (v) => dispatch({ type: 'spiralView', payload: v }),
    [dispatch]
  );

  const handleFocus = (field) => {
    dispatch({ type: 'focusedInput', payload: field });
  };

  const handleSelectBlur = (name, value) => {
    dispatch({ type: 'focusedInput', payload: null });
    handleInputChange(
      name,
      value,
      inputs,
      setInputs,
      setOptions,
      setSpiralView,
      { unit: unit }
    );
  };

  let checkedValue = value;
  if (checkedValue === null || checkedValue === undefined) {
    checkedValue = '';
  }
  if (typeof checkedValue === 'object') {
    const values = Object.values(checkedValue);
    checkedValue = Math.round(Math.max(...values) * 10) / 10;
  }
  if (typeof checkedValue === 'number') {
    checkedValue = Math.round(checkedValue * 10) / 10;
  }

  const [inputValue, setInputValue] = useState(checkedValue);

  useEffect(() => {
    setInputValue(checkedValue);
  }, [checkedValue]);

  const renderSelect = () => {
    let converted = false;

    const dictListToStringList = (list) => {
      return list.map((item) => {
        if (typeof item === 'object' && item !== null && !Array.isArray(item)) {
          converted = true;
          return Object.values(item).join('/');
        }
        return item;
      });
    };

    const stringToDict = (str) => {
      const values = str.split('/');
      return values.reduce((acc, value, index) => {
        acc[index + 1] = value;
        return acc;
      }, {});
    };

    const handleOptionSelection = (value) => {
      if (converted && typeof value === 'string') {
        handleInputChange(
          option.field,
          stringToDict(value),
          inputs,
          setInputs,
          setOptions,
          setSpiralView,
          { unit: unit }
        );
      } else {
        handleInputChange(
          option.field,
          value,
          inputs,
          setInputs,
          setOptions,
          setSpiralView,
          { unit: unit }
        );
      }
    };
    const optionChoice = dictListToStringList(option.options);

    return (
      <div className="input">
        <CustomSelect
          value={value}
          onChange={handleOptionSelection}
          disabled={disabled}
          optionChoice={optionChoice}
        />
      </div>
    );
  };

  const renderFloatField = () => {
    return (
      <div className="input">
        {disabled ? (
          <div className="result-text">{checkedValue}</div>
        ) : (
          <input
            type="text"
            inputMode="numeric"
            pattern="-?[0-9]*\.?[0-9]*"
            name={option.field}
            value={inputValue}
            onChange={(e) => {
              let val = e.target.value;
              if (option.step) {
                val = val.replace(/[^0-9-]/g, '');
              } else {
                val = val.replace(/[^0-9.-]/g, '');
                const parts = val.split('.');
                if (parts.length > 2) {
                  val = parts[0] + '.' + parts.slice(1).join('');
                }
              }
              val = val.replace(/(?!^)-/g, '');
              setInputValue(val);
            }}
            maxLength={10}
            onFocus={(e) => handleFocus(e.target.name)}
            onBlur={(e) => handleSelectBlur(option.field, e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') e.currentTarget.blur();
            }}
          />
        )}
      </div>
    );
  };

  const renderStrField = () => {
    return (
      <div className="input">
        {disabled ? (
          <div className="result-text">{value}</div>
        ) : (
          <input
            type="text"
            name={option.field}
            defaultValue={value}
            onFocus={(e) => handleFocus(e.target.name)}
            onBlur={(e) => handleSelectBlur(option.field, e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') e.currentTarget.blur();
            }}
            maxLength={100}
          />
        )}
      </div>
    );
  };

  const renderCheckBox = () => {
    const isChecked =
      typeof value === 'object' && value !== null
        ? Object.values(value).some((subValue) => Boolean(subValue))
        : Boolean(value);

    return (
      <div className="input">
        <div className="checkbox-container">
          <input
            type="checkbox"
            name={option.field}
            checked={isChecked}
            onChange={(e) =>
              handleInputChange(
                option.field,
                e.target.checked,
                inputs,
                setInputs,
                setOptions,
                setSpiralView
              )
            }
            className="checkbox-input"
            disabled={disabled}
            id={`checkbox-${option.field}`}
          />
          <label
            htmlFor={`checkbox-${option.field}`}
            className="checkbox-label"
          ></label>
        </div>
      </div>
    );
  };

  let inputRender;
  if (option.field === 'configuration') {
    inputRender = (
      <Configuration
        option={option}
        setOptions={setOptions}
        inputs={inputs}
        setInputs={setInputs}
        disabled={disabled}
        value={value}
      />
    );
  } else if (option.field === 'machine_type') {
    const optionChoice = option?.options;
    return (
      <ModelComponent
        optionChoice={optionChoice}
        setOptions={setOptions}
        inputs={inputs}
        setInputs={setInputs}
      />
    );
  } else if (option.input === 'select') {
    if (
      option.options.every((item) => typeof item === 'boolean') &&
      option.options.length > 0
    ) {
      inputRender = renderCheckBox();
    } else {
      inputRender = renderSelect();
    }
  } else if (option.input === 'float_field') {
    inputRender = renderFloatField();
  } else if (option.input === 'str_field') {
    inputRender = renderStrField();
  } else if (option.input === 'checkbox') {
    inputRender = renderCheckBox();
  } else {
    inputRender = <></>;
  }

  return inputRender;
}

export default RenderValueComponent;
